//import NotFoundData from "components/NotFoundData";
import styled from "@emotion/styled";
import { Row, Select, Image, Button } from "antd";
import { useAppDispatch, useAppSelector } from "store";
import { setLoading } from "store/slices/loadingSlice";
import NotFoundData from "components/NotFoundData";
import { Dispatch, FC, SetStateAction, useEffect } from "react";
import { GetDataOrderListData } from "services/interface";
import { useGetBankActiveList, useGetBankAllList } from "hooks/useFactory";
import OrderTableList from "components/OrderManage/OrderCredit/OrderTableList";
import SearchOrderForm from "../OrderTabsCard/SearchOrderForm";
import ExportToProduction from "./ExportToProduction";
import noImage from "assets/images/no-image.png";
const { Option } = Select;

interface OrderCreditProps {
  data: GetDataOrderListData | undefined;
  isLoading: boolean;
  refetch: () => void;
  setSearchInput: Dispatch<SetStateAction<string>>;
  searchInput: string; // currentPage: number;
  refectShipped?: () => void;
  refetchCancel?: () => void;
  IsHiddenPersonInfo?: boolean;
  refetchTo?: () => void;
  setDateInput: Dispatch<SetStateAction<string>>;
  dateInput: string;
  setOpenForm?: Dispatch<SetStateAction<boolean>>;
}

const OrderCredit: FC<OrderCreditProps> = ({
  data,
  isLoading,
  refetch,
  setSearchInput,
  searchInput,
  refectShipped,
  refetchCancel,
  IsHiddenPersonInfo,
  refetchTo,
  setDateInput,
  dateInput,
  setOpenForm
}) => {
  const dispatch = useAppDispatch();
  const factory_id = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { data: dataBank } = useGetBankActiveList(factory_id || "");
  const { contact } = useAppSelector((state) => state.auth);
  const userContactData = useAppSelector((state) => state.auth.contact);

  const childrenBank: React.ReactNode[] = [];
  dataBank?.data?.map((item) => {
    return childrenBank.push(
      <Option key={item.id} value={item.id}>
        <span style={{ fontSize: '12px' }}>
          <ImageWrapper>
            <Image src={item.image ?? noImage} alt={item.bank_name} preview={false} /> {item.bank_name} {item.account_no} {item.account_name}
          </ImageWrapper>
        </span>
      </Option>
    );
  });

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  }, [dispatch, isLoading]);


  const refetchData = () => {
    refetch();
    refetchTo && refetchTo();
  };

  return (
    <>
      <WrapperAll>
        <HeadWrapper>
          <SearchOrderForm
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
          />
          <RightIconWrapper>
            {setOpenForm && contact?.code === "lunganek" && (
              <Button type="primary" onClick={() => {
                setOpenForm(true);
              }}>
                เพิ่มคำสั่งซื้อ
              </Button>
            )}
          </RightIconWrapper>
        </HeadWrapper>
        <CardWrapperTable>
          <OrderTableList
            data={data}
            childrenBank={childrenBank}
            refetchData={refetchData}
            refetchTo={refetchTo}
            refetchCancel={refetchCancel}
            IsHiddenPersonInfo={IsHiddenPersonInfo}
            factory_id={userContactData?.id || ''}
          />
        </CardWrapperTable>
      </WrapperAll>
    </>
  );
};

export default OrderCredit;

const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
  background-color: #efefef;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;
const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const OptionContent = styled.div`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled.div`
  margin-right: 8px;
  width: 20px;  
  height: 20px; 
  img {
    width: 100%;
    height: 100%;
  }
`;